export function handleTurboFrameMissing(event) {
  const frame = event.target
  if (!(frame instanceof Element)) { return }
  event.preventDefault()

  const frameId = frame.id ? frame.id : 'Unknown'
  frame.innerHTML = `
    <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" id="turbo-frame-missing-overlay">
      <div class="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 relative">

        <div class="relative block w-full rounded-lg p-12 text-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mx-auto size-12 text-gray-400">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
          </svg>
          <span class="mt-2 block text-sm font-semibold text-gray-900">
            Frame not found: ${frameId}
          </span>
          <span class="mt-1 block text-sm text-gray-500">
            Try reloading the page.
          </span>
        </div>
      </div>
    </div>
  `

  const overlay = frame.querySelector('#turbo-frame-missing-overlay')

  function handleOverlayClick(e) {
    if (e.target === overlay || e.target === closeButton) {
      frame.innerHTML = ''
    }
  }

  overlay.addEventListener('click', handleOverlayClick)
}
